import type { FrontendWidget } from '../types';
import { ArticleCardComponent } from './ArticleCardComponent';
import type { ArticleCardConfig, ArticleCardResolved } from './types';

export const articleCardWidget: FrontendWidget<
  ArticleCardConfig,
  ArticleCardResolved
> = {
  componentType: 'magazine.article-card',
  displayName: 'Article Card',
  ComponentA: ArticleCardComponent,
  // No resolveSync — lookup widget. `MagazineContextService` resolves the
  // featured teaser once per render, before the resolver pass, because the
  // article grid's `exclude` needs the same answer.
};
